import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { Ancillary } from './Ancillary'
import { AncillaryTypes } from './AncillaryType'

export const ListOfAncillaryValidation = z.object({
  list: z.instanceof(Ancillary, { message: 'list is required' }).array(),
})

export class ListOfAncillary extends Model {
  static create({ list }: z.infer<typeof ListOfAncillaryValidation>) {
    ListOfAncillaryValidation.parse({ list })
    return new ListOfAncillary(list)
  }

  static fromJSON(json: ReturnType<ListOfAncillary['toJSON']>) {
    return ListOfAncillary.create({
      list: json.list.map(ancillaryJSON => Ancillary.fromJSON(ancillaryJSON)),
    })
  }

  static fromJSONOrEmpty(json: ReturnType<ListOfAncillary['toJSON']>) {
    try {
      return ListOfAncillary.fromJSON(json)
    } catch {
      return ListOfAncillary.empty()
    }
  }

  static empty() {
    return ListOfAncillary.create({ list: [] })
  }

  constructor(private readonly _list: Ancillary[]) {
    super()
  }

  get list() { return this._list } // prettier-ignore

  toJSON() {
    return { list: this._list.map(item => item.toJSON()) }
  }

  isEmpty() {
    return this._list.length === 0
  }

  map<T>(callback: (ancillary: Ancillary, index: number) => T) {
    return this._list.map(callback)
  }

  sortByType(order: AncillaryTypes[]) {
    return ListOfAncillary.create({
      list: this._list.sort((a, b) => order.indexOf(a.type) - order.indexOf(b.type)),
    })
  }
}
